import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-form-input-item" }
const _hoisted_2 = { class: "login-form-input-item__label" }
const _hoisted_3 = { class: "login-form-input-item__input" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  label?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'login-form-input-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    label: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('login-form-input-item', _ctx.modifires))
  }, [
    _createElementVNode("dl", _hoisted_1, [
      _createElementVNode("dt", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _createElementVNode("dd", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})